import { Message } from "../../types/types";
import { useState } from "react";
import styles from "./PromotionalMessageItem.module.scss";
import { PromotionalCountdownTimer } from "./PromotionalCountdownTimer/PromotionalCountdownTimer";
import cx from "classnames";
import { SaleTagIcon } from "../__shared__/SaleTagIcon/SaleTagIcon";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { InfoOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";

type Props = {
  message: Message;
  countdownTimerAvailabileToOrder: boolean;
  isBlackOverride: boolean;
  isPricePromise: boolean;
};

export const PromotionalMessageItem = ({
  message,
  countdownTimerAvailabileToOrder,
  isBlackOverride = false,
  isPricePromise = false,
}: Props) => {
  const [showInfo, setShowInfo] = useState(false);

  const handleTooltipExpandClick = () => {
    setShowInfo(!showInfo);
  };
  const handleTooltipCollapseClick = () => setShowInfo(false);

  const messageTitle = () => {
    const pricePromiseMessageType = "Price match price established";
    const pricePromiseManualOverrideRegex = /match/i;
    const promoMessageTitle = message.title;
    const lowerCaseFirstLetter =
      promoMessageTitle.charAt(0).toLowerCase() + promoMessageTitle.slice(1);

    if (isPricePromise && message.promotionType === pricePromiseMessageType) {
      const isManualOverride = promoMessageTitle.match(
        pricePromiseManualOverrideRegex,
      );
      if (!isManualOverride) return `Price matched: ${lowerCaseFirstLetter}`;
    }
    return promoMessageTitle;
  };

  return (
    <>
      <div className={styles.promoMessageContainer}>
        <div className={styles.messageContainer}>
          {message.title !== "Outlet" && (
            <SaleTagIcon type="small" isBlackOverride={isBlackOverride} />
          )}
          <p
            className={cx(
              styles.message,
              isBlackOverride && styles["blackOverride"],
            )}
          >
            {messageTitle()}
          </p>
          {message.description ? (
            <IconButton
              icon={InfoOutlined}
              aria-label={`${message.title} information`}
              data-testid="product:delivery-service:tooltip:button:expand"
              className={styles.promoToolTip}
              onClick={handleTooltipExpandClick}
            />
          ) : null}
        </div>
        <PromotionalCountdownTimer
          message={message.title}
          availableToOrder={countdownTimerAvailabileToOrder}
        />
      </div>
      <div
        data-testid="product:promotional-message:tooltip"
        className={showInfo ? styles.infoBlock : styles.infoBlockHide}
      >
        <IconButton
          icon={CloseOutlined}
          aria-label={"Collapse tooltip"}
          data-testid="product:promotional-message:tooltip:button:collapse"
          className={styles.closeButton}
          onClick={handleTooltipCollapseClick}
        />
        <div aria-live="polite" className={styles.tip}>
          <div dangerouslySetInnerHTML={{ __html: `${message.description}` }} />
        </div>
      </div>
    </>
  );
};
